import { Box, Typography } from "@mui/material"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos"
import { colors } from "../../../../styles/commonStyles"

const HeaderInfoNav = (props: any) => {
  const { name, handleClickBack, height, isBack = true } = props

  return (
    <Box
      sx={{
        height: height,
        width: "100%",
        backgroundColor: "#F8F9FA",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        // padding: "0px 20px",
      }}
    >
      <Typography component="h5" fontWeight={600} fontSize={"16px"}>
        {name}
        {isBack &&
          <Typography sx={{ color: colors.primaryBlack }}>
            <Box sx={{ cursor: "pointer" }} onClick={(e) => handleClickBack(e)}>
              <ArrowBackIosIcon sx={{ fontSize: "12px" }} /> Back
            </Box>
          </Typography>}
      </Typography>
    </Box>
  )
}

export default HeaderInfoNav
